<!--@formatter:off-->
<i18n src="./locale.json"></i18n>
<!--@formatter:on-->

<style lang="sass" scoped>
@import 'component'
</style>

<template lang="pug"> 
  div.form-group
    div(v-bind:class="isMaskListVisible ? 'active' : 'not-active'" v-on:click="isMaskListVisible = !isMaskListVisible") &plus;{{ code }}
    input(type="text" ref="field" v-bind:placeholder="$t('placeholder_phone_number')" v-bind:value="number" v-on:input="update")
    transition(name="list")
      ul(v-if="isMaskListVisible")
        li(class="lang-btn" v-for="(lang, key) in countries" v-on:click="onPhoneCodeChange(countries[key]['COUNTRY_CODE'], key)" v-bind:class="code == countries[key]['COUNTRY_CODE'] ? 'active' : ''" v-bind:key="key")
          span {{ lang['COUNTRY_CODE'] }} &nbsp; {{ lang['FULLNAME'] }}
</template>

<script>
import InputMask from 'inputmask/dist/inputmask/inputmask';
import { mapActions, mapGetters } from 'vuex';
import 'inputmask/dist/inputmask/inputmask.numeric.extensions';

export default {
  data() {
    return {
      isMaskListVisible: false,
    };
  },

  props: ['code', 'number'],

  computed: {
    ...mapGetters('configuration', {
      country: 'getCountry',
      countries: 'getCountries',
      phoneMask: 'getPhoneMask',
    }),
  },

  mounted() {
    new InputMask(this.phoneMask).mask(this.$refs.field);
  },

  methods: {
    ...mapActions('configuration', ['setCountry']),

    onPhoneCodeChange(phoneCode, country) {
      this.isMaskListVisible = false;
      this.setCountry(country);
      this.$emit('update:code', this.code.replace(/\D/g, ''));
    },

    update(event) {
      this.$emit('update:number', event.target.value.replace(/\D/g, ''));
    },
  },
};
</script>
